import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { useCaptureImageMutation } from 'services/assets'

export const generateRequestImagesFunction = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [captureImage] = useCaptureImageMutation()
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { selectedCameraIds, scaleCameras } = useSelector(state => state.devices)

  const requestImages = async (callback, scaleId, specificCameraIds = null) => {
    const cameraIds = scaleId && scaleCameras[scaleId]?.length ? scaleCameras[scaleId] : selectedCameraIds

    const camerasToCapture = specificCameraIds || cameraIds

    const imageData = await camerasToCapture.reduce(async (prevPromise, cameraId) => {
      const results = await prevPromise
      const imageResponse = await captureImage({ deviceId: cameraId }).unwrap()
      return [...results, { deviceId: cameraId, imageFilename: imageResponse.filename }]
    }, Promise.resolve([]))

    callback(imageData)
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const debouncedRequestImages = useCallback(debounce(requestImages, 1000, { leading: true, trailing: false }), [
    selectedCameraIds,
    scaleCameras,
  ])
  return {
    requestImages: debouncedRequestImages,
  }
}
